import { render, staticRenderFns } from "./status_label.vue?vue&type=template&id=fbf5255a&scoped=true&"
import script from "./status_label.vue?vue&type=script&lang=js&"
export * from "./status_label.vue?vue&type=script&lang=js&"
import style0 from "./status_label.vue?vue&type=style&index=0&id=fbf5255a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf5255a",
  null
  
)

export default component.exports